cv.TeamView = Marionette.LayoutView.extend({
  className : 'page-dashboard',
  
  template: cv.Templates['team/view'],

  regions : {
    team_progress : '#team-progress'
  },

  bindings : {
    ':el' : {
      observe : 'photo_path',
      update: function($el, value, model, options) {
        var $replace = $el.find('.profile-photo').clone();

        $replace.attr('data-src', cv.photo({
          photo_path : model.get('photo_path'),
          photo_default : cv.campaign.get('default_team_photo'),
          url_only : true,
          transforms : {
            fit : 'crop'
          }
        }));
        
        $el.find('.profile-photo').replaceWith($replace);

        setTimeout(_.bind(function(){
          imgix.fluid($el.get(0), {
            updateOnResizeDown: false,
            pixelStep: 5,
            autoInsertCSSBestPractices: true
          });
        }, this), 50);
      }
    }
  },

  events : {
    'click .leave-team' : 'leaveTeam',
    'click .delete-team' : 'deleteTeam'
  },

  validation: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('TeamView initialized.');
  },

  templateHelpers: function(){
    return {
      project_stub : cv.project.get('stub'),
      team_id : this.model.get('id'),
      url : this.model.get('url'),
      name : this.model.get('name'),
      is_admin : cv.project.get('team.role') == 'admin' ? true : false
    }
  },

  leaveTeam: function(e){
    e.preventDefault();

    if(this.model.get('num_members') == 1){
      var view = new cv.ConfirmView({
        message : 'Are you sure you want to leave this team?  As the only member, this team will be deleted.'
      });
    }else{
      var view = new cv.ConfirmView({
        message : 'Are you sure you want to leave this team?'
      });
    }
    vent.trigger('modal:show', view);

    view.on('confirm', function(){
      $.ajax({
        url: cv.api_path + '/teams/' + this.model.get('id') + '/remove_member/' + cv.project.get('id'),
        dataType: "json",
        type: 'POST',
        success: _.bind(function(data){
          vent.trigger('tray:hide');
          vent.trigger('notif:success', 'You have successfully left this team.');

          if(this.model.get('num_members') == 1){
            setTimeout(function(){
              top.location = '/' + cv.project.get('stub') + '/admin/dashboard';
            }, 1000);
          }else{
            top.location.reload();
          }
        }, this),
        error: _.bind(function(data){
          vent.trigger('notif:error', $.parseJSON(data.responseText).data);
        }, this)
      });
    }, this);
  },

  deleteTeam: function(e){
    e.preventDefault();

    var view = new cv.ConfirmView({
      message : 'Are you sure you want to delete this team?  The team will be deleted and all members removed.'
    });
    vent.trigger('modal:show', view);

    view.on('confirm', function(){
      $.ajax({
        url: cv.api_path + '/teams/' + this.model.get('id'),
        dataType: "json",
        type: 'DELETE',
        success: _.bind(function(data){
          vent.trigger('notif:success', 'You have successfully deleted this team.');

          setTimeout(function(){
            top.location = '/' + cv.project.get('stub') + '/admin/dashboard';
          }, 1000);
        }, this),
        error: _.bind(function(data){
          vent.trigger('notif:error', $.parseJSON(data.responseText).data);
        }, this)
      });
    }, this);
  },

  onAttach: function(){
    this.stickit();

    this.showChildView('team_progress', new cv.DashboardProgressView({
      type : 'team',
      active : true,
      model : this.model
    }));
  }
});
